import { Component, Input } from '@angular/core';
import { IGenericModal } from '@interfaces/genericModal.interface';

@Component({
    selector: 'app-generic-modal',
    templateUrl: './generic-modal.component.html',
    styleUrls: ['./generic-modal.component.scss'],
    standalone: false
})
export class GenericModalComponent {
    @Input() data?: IGenericModal;
}
